import { utils } from '@febos-io/common';

export const getExamList = (page, limit = 1) => ({
  path: 'v1/exams',
  params: {
    page,
    limit
  }
});

export const getMyExamList = (
  {
    page = 1,
    limit = 10,
    filter = ''
  }
) => ({
  path: '/v1/person/me/dental-exam',
  params: {
    page,
    limit,
    filter
  }
});

export const getExamByCodeAccess = (code) => ({
  path: `v1/person/me/dental-exam/shared/${code}`
});

export const shareMyExam = (type, examId, {
  email
}) => ({
  path: `v1/person/me/${type}/${examId}/share`,
  method: utils.METHOD.POST,
  content: {
    email
  }
});
